import React from "react";
import { Clock, CheckCircle, XCircle, MoonStars } from "@phosphor-icons/react";

export const AGENT_STATUS_META = {
  pending:   { label: "Pending",   color: "amber",   Icon: Clock,        cls: "bg-amber-500/10 text-amber-300 border-amber-400/40" },
  active:    { label: "Active",    color: "emerald", Icon: CheckCircle,  cls: "bg-emerald-500/15 text-emerald-300 border-emerald-400/40" },
  suspended: { label: "Suspended", color: "red",     Icon: XCircle,      cls: "bg-red-500/15 text-red-300 border-red-400/40" },
  inactive:  { label: "Inactive",  color: "gray",    Icon: MoonStars,    cls: "bg-white/5 text-white/50 border-white/15" },
};

export function AgentStatusBadge({ status, size = "sm", showIcon = true, className = "", "data-testid": testId }) {
  const meta = AGENT_STATUS_META[status] || AGENT_STATUS_META.pending;
  const { Icon, label, cls } = meta;
  const px = size === "lg" ? "px-3 py-1 text-xs" : size === "md" ? "px-2.5 py-0.5 text-[11px]" : "px-2 py-0.5 text-[10px]";
  const iconSize = size === "lg" ? 14 : 12;
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${px} rounded-full uppercase tracking-widest border font-sans ${cls} ${className}`}
      data-testid={testId || `agent-status-${status}`}
    >
      {showIcon && <Icon size={iconSize} weight="duotone" />}
      {label}
    </span>
  );
}
